<template>
  <div>
    <span>{{ item.text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
  },
}
</script>
